function toQueryString(query) {
  const queryString = new URLSearchParams(query).toString();

  return queryString ? `?${queryString}` : '';
}

export default toQueryString;
